import React, { useState } from 'react';
import { EvaluationResult, PredictionSegment } from '../types';
import { useTranslation } from 'react-i18next';

interface EvaluationResultsProps {
  evaluationResult: EvaluationResult;
  onSegmentClick: (start: number, end: number) => void;
}

export const EvaluationResults: React.FC<EvaluationResultsProps> = ({ evaluationResult, onSegmentClick }) => {
  const { t } = useTranslation();
  
  // Format time for segments
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  // État pour gérer l'affichage des segments
  const [showAllSegments, setShowAllSegments] = useState<boolean>(false);
  
  // Nombre de segments à afficher par défaut
  const defaultVisibleSegments = 6;

  if (!evaluationResult || evaluationResult.prediction === null) {
    return null;
  }

  // Vérifier s'il y a plus de segments que le nombre par défaut
  const hasMoreSegments = evaluationResult.prediction_list && evaluationResult.prediction_list.length > defaultVisibleSegments;
  
  // Segments à afficher
  const visibleSegments = showAllSegments 
    ? evaluationResult.prediction_list 
    : evaluationResult.prediction_list?.slice(0, defaultVisibleSegments);

  return (
    <div className="card">
      <h2>{t('evaluation.resultsTitle')}</h2>
      
      {/* Scores par segment */}
      <div className="scores-container">
        <h3>{t('evaluation.segmentScoresTitle')}</h3>
        {evaluationResult.prediction_list && evaluationResult.prediction_list.length > 0 ? (
          <>
            {visibleSegments?.map((segment: PredictionSegment, index: number) => (
              <div 
                key={index} 
                className="score-segment clickable"
                onClick={() => onSegmentClick(segment.start, segment.end)}
              >
                <span>
                  {t('evaluation.segmentLabel', {
                    index: index + 1,
                    start: formatTime(segment.start),
                    end: formatTime(segment.end)
                  })}
                </span>
                <span>{segment.prediction.toFixed(2)}</span>
              </div>
            ))}
            
            {/* Bouton pour afficher plus/moins */}
            {hasMoreSegments && (
              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <button 
                  className="button"
                  onClick={() => setShowAllSegments(!showAllSegments)}
                  style={{ backgroundColor: '#f5f5f5', color: 'rgb(72, 78, 82)', border: '1px solid #ddd' }}
                >
                  {showAllSegments ? t('evaluation.showLess') : t('evaluation.showMore')}
                </button>
              </div>
            )}
          </>
        ) : (
          <p style={{ textAlign: 'center', color: '#666' }}>
            {t('evaluation.noSegments')}
          </p>
        )}
      </div>
    </div>
  );
};
